import PropTypes from 'prop-types';
import React from 'react';
import MetricInfo from './MetricInfo';

/**
 * Standard card wrapper for analytics sections — soft surface, consistent
 * padding, a title row with an optional metric-explanation icon and an actions
 * slot (tabs, filters, export buttons). Replaces the ad-hoc bordered divs.
 */
const SectionCard = ({
  title,
  subtitle,
  metricKey,
  actions,
  className = '',
  bodyClassName = '',
  children,
}) => (
  <section
    className={`rounded-lg border border-grey bg-white ${className}`}
    style={{ boxShadow: 'var(--sc-shadow-card)' }}
  >
    {(title || actions) && (
      <header className="flex items-start justify-between gap-3 px-5 pt-4">
        <div className="min-w-0">
          {title && (
            <div className="flex items-center gap-1">
              <h3 className="truncate text-base font-semibold text-black">
                {title}
              </h3>
              {metricKey && <MetricInfo metricKey={metricKey} />}
            </div>
          )}
          {subtitle && (
            <p className="mt-0.5 text-sm text-grey-darker">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 items-center gap-2">{actions}</div>
        )}
      </header>
    )}
    <div className={`px-5 pb-5 pt-4 ${bodyClassName}`}>{children}</div>
  </section>
);

SectionCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  metricKey: PropTypes.string,
  actions: PropTypes.node,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  children: PropTypes.node,
};

export default SectionCard;
